import { render, staticRenderFns } from "./ModuleFour.vue?vue&type=template&id=72b0c8e0&scoped=true"
import script from "./ModuleFour.vue?vue&type=script&lang=js"
export * from "./ModuleFour.vue?vue&type=script&lang=js"
import style0 from "./ModuleFour.vue?vue&type=style&index=0&id=72b0c8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0c8e0",
  null
  
)

export default component.exports